module.exports = __webpack_public_path__ + "img/taxo.ad701e6f.jpg";